import HolidayService from '../../../common/service/holidayService';

const FETCH_NOTIFICATION_LIST_URL = '/seller/notifications';
const SET_NOTIFICIATION_STATUS_URL = '/seller/notification/status';

const getNotificationsList = data => HolidayService.post(FETCH_NOTIFICATION_LIST_URL, data);

const setNotificationStatus = data => HolidayService.post(SET_NOTIFICIATION_STATUS_URL, data);

export { getNotificationsList, setNotificationStatus };
